import {useLoaderData} from "react-router-dom";

import {useNotifyStore} from '../../../../../Stores/notify';

import TelegramNotifications from "../../../Components/TelegramNotifications"

import ProfileActions from '../../../Components/ProfileActions';

import './index.scss';

export default function TelegramNotificationsPage() {
    const initData = useLoaderData();
    const {showNotify} = useNotifyStore();

    const onNotificationsSubmit = () => {
        showNotify({text: "Конфігурація успішно збережена"});
    }

    return <div className="ProfilePage ProfileNotifications">
        <TelegramNotifications config={initData} onSubmit={onNotificationsSubmit}/>
        <ProfileActions />
    </div>
}
